/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/



import React, { forwardRef } from "react";
import { useState, useEffect } from "react";
import * as API from "../../../api/emr";
import Loading from "react-loading";
import { Modal } from "react-bootstrap";
import GeneralInformation from "./GeneralInformation";
import EmrSummary from "./EmrSummary";

const EmrSummaryModal = ({ row, showModal, handleClose }) => {

    return (
        <>
            <Modal
                show={showModal}
                onHide={handleClose}
                dialogClassName="modal-lg"
            >
                <Modal.Header closeButton className="bg-thumbcolor">
                    <Modal.Title id="example-modal-sizes-title-lg">
                        EMR Summary
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <>
                        <GeneralInformation row={row} />
                        <EmrSummary row={row} />
                    </>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default EmrSummaryModal